document.addEventListener('DOMContentLoaded', function () {
  initCardSliders();

  const observer = new MutationObserver(() => {
    initCardSliders();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function initCardSliders() {
  document.querySelectorAll('.ppspy-exp-view-root').forEach(el => el.style.pointerEvents = 'none');

  document.querySelectorAll('.card-wrapper').forEach(card => {
    const mediaDiv = card.querySelector('.card__media');
    if (!mediaDiv) return;

    const images = mediaDiv.querySelectorAll('img');
    if (images.length <= 1) return;

    if (card.dataset.sliderInit) return;
    card.dataset.sliderInit = 'true';

    let currentIndex = 0;

    const prevBtn = document.createElement('button');
    prevBtn.className = 'card-slider-arrow card-slider-prev';
    prevBtn.setAttribute('aria-label', 'Imagen anterior');
    prevBtn.setAttribute('type', 'button');
    prevBtn.innerHTML = '&#8249;';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'card-slider-arrow card-slider-next';
    nextBtn.setAttribute('aria-label', 'Imagen siguiente');
    nextBtn.setAttribute('type', 'button');
    nextBtn.innerHTML = '&#8250;';

    card.style.position = 'relative';
    card.appendChild(prevBtn);
    card.appendChild(nextBtn);

    images.forEach((img, i) => {
      if (i === 0) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.3s ease';
      img.style.position = 'absolute';
      img.style.inset = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.zIndex = '1';
    });

    function goTo(index) {
      images[currentIndex].style.opacity = '0';
      currentIndex = (index + images.length) % images.length;
      images[currentIndex].style.opacity = '1';
    }

    // Exponer goTo para el listener global de swatches
    card._sliderGoTo = goTo;

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      goTo(currentIndex + 1);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchOnMedia = false;

    card.addEventListener('touchstart', (e) => {
      const touch = e.changedTouches[0];
      const mediaRect = mediaDiv.getBoundingClientRect();
      touchOnMedia = (
        touch.clientX >= mediaRect.left &&
        touch.clientX <= mediaRect.right &&
        touch.clientY >= mediaRect.top &&
        touch.clientY <= mediaRect.bottom
      );
      touchStartX = touch.screenX;
      touchStartY = touch.screenY;
    }, { passive: true });

    card.addEventListener('touchmove', (e) => {
      if (!touchOnMedia) return;
      const diffX = Math.abs(touchStartX - e.changedTouches[0].screenX);
      const diffY = Math.abs(touchStartY - e.changedTouches[0].screenY);
      if (diffX > diffY) e.preventDefault();
    }, { passive: false });

    card.addEventListener('touchend', (e) => {
      if (!touchOnMedia) return;
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      }
    }, { passive: true });
  });
}

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  if (typeof card._sliderGoTo === 'function') {
    card._sliderGoTo(0);
  }
}, true); // 👈 el "true" activa capture phase, se ejecuta ANTES de stopPropagation

